<template>
    <div class="h-dialogContainer">
        <!--<div class='col-sm-4' >-->
        <div  class="dp-left-width" >
          <ServerDetailLeft ref="leftInfo" :detailShow="detailShow" :detailShowList="detailShowList" :detailInfo="detailInfo" :buttonShow="deployFlag" :delButtonShow="delButtonShow"></ServerDetailLeft>
        </div>
        <div class="dp-right-width">
          <div class='h-ainfoBg' >
            <div class='h-ainfo'>
              <span class='icon hero-icon hero-icon-detailcode'></span>
              <span v-if="deployTotalFlag">{{$t('DeployManagement.versionCount')}} {{versionNum}} {{$t('DeployManagement.deployTotal')}} {{deployedNum}} </span>
              <span v-if="!deployTotalFlag">{{$t('DeployManagement.versionCount')}} {{versionNum}} </span>
            </div>
          </div>
          <div class="h-right">
          <ejs-tab ref='deployedTab' heightAdjustMode='heightAdjustMode' cssClass='tabsClass' :selectedItem="selectedItem" :selecting="tabSelecting">
            <div class="e-tab-header h-subscriber-subTabs-header">
              <div v-for="item of headers" :key="item.key">{{item.text}}</div>
            </div>
            <div class="e-content h-subscriber-subTabs-content">
              <div id='deployed'>
                <Table ref="deployedData" :qryParam="qryParam"></Table>
              </div>
              <div id='server'>
                <Table ref="serverData" :qryParam="qryParam" rowSelectedflag="true"></Table>
              </div>
            </div>
          </ejs-tab>
          </div>
        </div>
    </div>
</template>

<script>
import Table from '../serverManagement/Table';
import { EventBus } from '../../../plugins/eventBus';
import ServerDetailLeft from '../ServerDetailLeft';

export default {
  name: 'ServerDetailDialog',
  components: {
    Table,
    ServerDetailLeft
  },
  data() {
    return {
      headers: [
        { text:  this.$t('DeployManagement.deployTab'), iconCss: 'tabsClass', key: 'deployed' },
        { text:  this.$t('DeployManagement.versionTab'), iconCss: 'tabsClass', key: 'server' },
      ],
      deployedNum: 0,
      versionNum: 0,
      selectedItem: 1,
      qryParam: {
        oamTypeCode: undefined,
        version: undefined,
        deliverType: undefined
      }, // 查询条件---产品名称枚举值
      detailInfo: {
        serviceName: '',
        deliverType: '0',
        description: '',
        createTime: ''
      },
      deployFlag: false,
      delButtonShow: false,
      detailShow: {
        description: true,
        deliverType: true,
        createTime: true
      },
      detailShowMap: {
        description: this.$t('DeployManagement.description'),
        deliverType: this.$t('DeployManagement.deliverTypeStr'),
        createTime: this.$t('DeployManagement.lunchTime'),
        pkgVersion: this.$t('DeployManagement.pkgVersion'),
        // type: this.$t('DeployManagement.classify')
      },
      detailShowList: [],
      temDetailShowList: [],
      innerLocale: undefined,
      tempSelectedMap: new Map(),
      detailShowListBak: undefined,
      unDeployedList: [10001,10004,10009,3,4,5,6,7,17,18],//定义不显示部署按钮集合
      deployTotalFlag: true,
    };
  },
  methods: {
    setQryParam(oamType, version, deliverType) {
      this.qryParam.oamTypeCode = oamType;
      this.qryParam.version = version;
      this.qryParam.deliverType = deliverType;
      //添加某些类型不显示部署数量
      let flag = this.unDeployedList.findIndex(item => item === oamType)
      if (flag < 0 ){
        this.deployTotalFlag = true;
      }else{
        this.deployTotalFlag = false;
      }
    },
    initTable(target) {
      this.deployedNum = target.deployedCount;
      // this.selectedItem = 1;
      // this.$refs.deployedTab.select(1);
      this.detailInfo = target;
      // 初始化左侧组件
      this.detailShowList = [
        // { name: this.detailShowMap['type'], value: target.type},
        { name: this.detailShowMap['createTime'], value: target.createTime}
      ];
      this.detailShowListBak = [
        // { name: this.detailShowMap['type'], value: target.type},
        { name: this.detailShowMap['createTime'], value: target.createTime}
      ];
      this.$refs.serverData.init(3, this.unDeployedList);
      this.$refs.deployedData.init(2);
    },

    tabSelecting: function(args){
      if(0==args.selectingIndex){//选中用户实例
        this.temDetailShowList= JSON.parse(JSON.stringify(this.detailShowList));
        this.detailShowList = this.detailShowList.filter(item => item.name == "上架时间");
        this.$refs.leftInfo.showAll=false;
      } if(1==args.selectingIndex){//选中所有版本
        this.detailShowList=this.temDetailShowList;
        this.$refs.leftInfo.showAll=true;
      }
    },
  },
  created() {
    EventBus.$on('updateTotalNum', target => {
      this.versionNum = target.versionNum;
    });

    EventBus.$on('updateDetail', target => {
      console.log("-------------->");
      console.log(target);
      if (this.tempSelectedMap.get(target.pkgVersion)) {
        console.log('不需要再查介绍查询', this.detailInfo);
        this.detailInfo = this.tempSelectedMap.get(target.pkgVersion);
      } else {
        this.detailInfo = target;
        if (this.detailInfo.deliverTypeId === 2) {
          if (!this.innerLocale) {
            let locale = localStorage.getItem('locale');
            if (locale === "zh") {
              this.innerLocale = "zh_CN";
            } else {
              this.innerLocale = "en_US";
            }
          }
          const url = "/lte/ems/nf/getParamJson";
          // 查询应用介绍信息
          const qryDescription = {
            info: {
              processName: "ems_mano",
              path: this.detailInfo.configPath,
              i18n: this.innerLocale
            }
          };
          this.$axios.post(url, qryDescription).then((res) => {
            const result = JSON.parse(res.data.resultVal);
            this.$refs.leftInfo.updateShowInfo(0, result.info.package.description);
            this.detailInfo.description = result.info.package.description;
            // this.detailShowList[0].description = result.info.package.description;
          });
        }
        this.tempSelectedMap.set(target.pkgVersion, this.detailInfo);
      }
      console.log('===============', this.detailInfo);// 为什么调用两遍
      this.delButtonShow = true;
      //微服务 旧版本   没有描述信息
      if (this.detailInfo.deliverTypeId === 1 || this.detailInfo.deliverTypeId === 0) {
        this.detailShowList = [
          { name: this.detailShowMap['deliverType'], value: this.detailInfo.deliverType},
          { name: this.detailShowMap['createTime'], value: this.detailInfo.createTime},
          { name: this.detailShowMap['pkgVersion'], value: this.detailInfo.pkgVersion},
        ];
      } else{
        //d项目有描述信息，且是二次查询获取的
        this.detailShowList = [
          { name: this.detailShowMap['description'], value: this.detailInfo.description},
          { name: this.detailShowMap['deliverType'], value: this.detailInfo.deliverType},
          { name: this.detailShowMap['createTime'], value: this.detailInfo.createTime},
          { name: this.detailShowMap['pkgVersion'], value: this.detailInfo.pkgVersion},
        ];
      }
      // deliverTypeId=0 native可以部署  1：image 2:helm
      //添加某些类型不显示部署按钮
      let flag = this.unDeployedList.findIndex(item => item === target['oamTypeCode'])
      if (flag<0 && (this.detailInfo.deliverTypeId === 0
        // || (this.detailInfo.deliverTypeId === 1 && this.detailInfo.existNum === 0)
        || (this.detailInfo.deliverTypeId === 2 && this.detailInfo.existNum === 0))) {
        this.deployFlag = true;
      } else {
        this.deployFlag = false;
      }
    });

    EventBus.$on('updateInitDetail', () => {
      this.delButtonShow = false;
      this.detailShowList = JSON.parse(JSON.stringify(this.detailShowListBak));
      this.deployFlag = false;
    });
    EventBus.$on('deletePackage', target => {
      this.delButtonShow = false;
      this.$refs.serverData.freshServerList(target.oamTypeCode, target.deliverType);
      if (this.$refs.serverData.getDataListSize() <= 1){
        EventBus.$emit('closeDetail', {});
      }
    });
  }
};
</script>

<style scoped>

  .h-dialogContainer{
     height:100%;width:100%;
   }
</style>
